import { Container } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useContext } from 'react';
import { Page } from 'components';
import { ticketTypeContext, ticketTypeSchema } from './TicketTypeContext';
import { TicketTypeForm } from './components';


let NewTicket = () => {

    let { isLoading,saveTicketType, ticketType } = useContext(ticketTypeContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="Ticket Type"
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={ticketTypeSchema}
                    initialValues={ticketType}
                    onSubmit={(values, action) => {
                        saveTicketType(values);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <TicketTypeForm />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default NewTicket;